import { Button } from '../Button/Button';
import content from './content';
import { useLanguageCtx } from '../../../store/providers/LanguageContext';

const IndustryFooterButtonSection = () => {
  const {language} = useLanguageCtx();

  return (
    <div
      className="all-width flex center-content-items"
      style={{ height: "207px", backgroundColor: "#F0F3F7" }}
    >
      <Button
        type="button light-blue"
        content={content[language].button_text}
      />
    </div>
  );
}

export default IndustryFooterButtonSection
